import PropTypes from 'prop-types';
import React from 'react';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';

import VoiceTrackIcon from '../../../static/icons/ic_voicetrack_16.svg';
import { GridConstants } from '../../constants/Grid';
import { messages as playlistMessages } from '../../constants/PlaylistT3';
import { PandoraTypes } from '../../constants/SourceTypes';
import { getInDomain } from '../../domains/externalUtils';
import { getArt, getDominantColor } from '../../lib/ArtUtils';
import { mapCuratorProps } from '../../lib/CuratorSourcesUtils';
import { getAnnotationsById } from '../../lib/EntityUtils';
import { getCurrentUserWebName } from '../../lib/ListenerUtils';
import { isRadioOnly, isUnavailable } from '../../lib/RightsUtils';
import { getProfilePath } from '../../lib/RouteUtils';
import { getSourceCardMenuItems } from '../../lib/SourceCardUtils';
import Icon from '../Icon';

import CatalogRowItem from './CatalogRowItem';

const voiceTrackIcon = <Icon glyph={VoiceTrackIcon} />;

class PlaylistRowItem extends React.Component {
  static propTypes = {
    id: PropTypes.string,
    pandoraType: PropTypes.string,
    hideAuthor: PropTypes.bool,
    numSongs: PropTypes.number,
    author: PropTypes.string,
    playlistOwnerWebname: PropTypes.string,
    intl: PropTypes.object,
    isHosted: PropTypes.bool,
    curatorName: PropTypes.string,
    curatorUrlPath: PropTypes.string,
  };

  static defaultProps = {
    pandoraType: PandoraTypes.PLAYLIST,
  };

  getSecondTextProps = () => {
    const { curatorName, curatorUrlPath, author, hideAuthor, playlistOwnerWebname } = this.props;

    if (curatorName && curatorUrlPath) {
      return {
        secondTextModifier: this.props.intl.formatMessage(playlistMessages.playlistBy, {
          author: '',
        }),
        secondText: curatorName,
        secondTextUrl: curatorUrlPath,
      };
    } else if (author && !hideAuthor) {
      // Don't show author if the author is the current user
      return {
        secondTextModifier: this.props.intl.formatMessage(playlistMessages.playlistBy, {
          author: '',
        }),
        secondText: author,
        secondTextUrl: getProfilePath(playlistOwnerWebname),
      };
    }

    return {
      secondTextModifier: this.props.intl.formatMessage(playlistMessages.playlist),
      secondText: '',
      secondTextUrl: null,
    };
  };

  render() {
    const secondTextProps = this.getSecondTextProps();
    const props = {
      ...secondTextProps,
      mainTextModifier: this.props.isHosted ? voiceTrackIcon : null,
      rightColChild: this.props.intl.formatMessage(playlistMessages.songs, {
        numSongs: this.props.numSongs,
      }),
    };

    return <CatalogRowItem {...props} {...this.props} />;
  }
}

export function mapStateToProps(state, ownProps) {
  const props = {};
  const details = getAnnotationsById(state, ownProps.id);
  props.blankItem = !details;
  if (details && ownProps.id) {
    const isEditable = getInDomain('playback.utils.isPlaylistEditable', false)(details);
    const owner = getInDomain('catalog.utils.getAnnotations')(
      state,
      details.get('listenerPandoraId'),
    );
    const { curatorName, curatorUrlPath } = mapCuratorProps(state, ownProps.id);

    props.sourceCardMenuItems = getSourceCardMenuItems({
      state,
      pandoraId: ownProps.id,
      pandoraType: PandoraTypes.PLAYLIST,
      shareParentSource: {
        shareParentSourceId: ownProps.id,
        shareParentSourceType: PandoraTypes.PLAYLIST,
      },
      playlistData: { isEditable },
    });
    props.isPlayingCurrently = getInDomain('playback.utils.isSourcePlayingCurrently', false)(
      state,
      ownProps.id,
    );
    props.mainText = details.get('name');
    props.mainTextUrl = details.get('shareableUrlPath');
    props.playlistOwnerWebname = owner && owner.get('webname');
    props.author = owner && (owner.get('displayname') || owner.get('webname'));
    props.hideAuthor = getCurrentUserWebName(state) === owner.get('webname');
    props.numSongs = details.get('totalTracks');
    // If a playlist has zero tracks, don't show play button
    props.hidePlayButton = props.numSongs === 0;
    props.imgUrl = getArt(details, GridConstants.GRID_ITEM_IMAGE_SIZE, state);
    props.isRadioOnly = isRadioOnly(details);
    props.isUnavailable = isUnavailable(details);
    props.isExplicit = getInDomain('catalog.utils.isExplicit')(details);
    props.isClean = getInDomain('catalog.utils.isClean')(details);
    props.dominantColor = getDominantColor(details);
    props.isHosted = getInDomain('catalog.utils.isHostedPlaylist', false)(state, ownProps.id);
    props.curatorName = curatorName;
    props.curatorUrlPath = curatorUrlPath;
  }
  return props;
}

export default injectIntl(connect(mapStateToProps, {})(PlaylistRowItem));
